import './styles.scss'

import { useTranslation } from 'react-i18next'
import { Modal } from 'antd'

import CustomButton from '@/components/CustomButton'

interface EmptyCartConfirmModalProps {
  isEmptyCartModalVisible?: boolean
  onEmptyCart: () => void
  onCancel: () => void
}

const EmptyCartConfirmModal = ({
  isEmptyCartModalVisible = false,
  onEmptyCart,
  onCancel,
}: EmptyCartConfirmModalProps) => {
  const { t } = useTranslation()

  return (
    <Modal
      open={isEmptyCartModalVisible}
      title={t('cart.modal.title')}
      footer={
        <div className="confirm-modal__footer">
          <CustomButton type="ghost" onClick={onCancel}>
            {t('cart.modal.cancelBtn')}
          </CustomButton>
          <CustomButton onClick={onEmptyCart}>
            {t('cart.modal.confirmBtn')}
          </CustomButton>
        </div>
      }
      onCancel={onCancel}
      onOk={onEmptyCart}
    >
      <span>{t('cart.modal.emptyCartContent')}</span>
    </Modal>
  )
}

export default EmptyCartConfirmModal
